<div class="ra-toolbar">
    @if (CountLine) {
        <p class="ra-toolbar__meta" role="status">
            @if (CountLine.Bold !== null) {<b>{{ CountLine.Bold }}</b>}{{ CountLine.Text }}
        </p>
    }
    <agu-sort-trigger [Options]="TriggerOptions" [Value]="Sort" (ValueChange)="SortChange.emit($event)" />
    <!-- The phone's icon key (`.mlegend.in-tb`, P/Member_Hub.html:694-700, 1001-1004): decorative, each dot names itself. -->
    <div class="ra-toolbar__legend" aria-hidden="true">
        @for (entry of Legend; track entry.Kind) {
            <span><i [class]="'ra-toolbar__dot ra-toolbar__dot--' + entry.Kind"></i>{{ entry.Label }}</span>
        }
    </div>
</div>
